<template>
    <div id="organismFaq" class="col-12 px-0 my-4">
        <p class="text-left title-group">Perguntas cadastradas</p>
        <draggable
            :force-fallback="true"
            :list="totalForm" 
            @start="drag=true"
            @end="drag=false"
            v-bind="{ handle: '.handle'}"
        >
            <div class="row justify-content-center" v-for="(item, index) in totalForm" :key="index">
                <div class="col-12 px-0 px-md-4 text-left py-3">
                    <div class="card py-3 drag">
                        <div class="d-flex justify-content-md-between justify-content-end">
                            <div :class="`col-auto text-left handle align-items-center cursor-pointer ${item.open ? 't-y' : ''}`">
                                <i class="fal fa-bars opacity-50"></i>
                            </div>
                            <div v-show="item.open == false" style="display:flex" class="col text-left pl-0 cursor-pointer flex-column justify-content-center align-items-start"  @click.prevent="collapse(index,item)" >
                                <p class="m-0 card-title"><strong>{{verifyTitle(item.title) | editText}}</strong></p>
                                <p class="m-0 card-text" v-if="!(verifyTitle(item.text) == 'Campo vazio') && !(verifyTitle(item.text) ==  'Campo vazio')">{{verifyTitle(item.text) | editText}}</p>
                            </div>
                            <div class="col-2 col-md-auto text-right list-actions">
                                <span class="item-settings-button" v-if="!item.open" @click.prevent="collapse(index,item)">
                                    <i class="fal fa-pencil-alt" ></i>
                                </span>
                                <span class="item-settings-button" v-else @click.prevent="collapse(index,item)">
                                    <i class="fal fa-check"></i>
                                </span>
                                 <span class="item-settings-button" @click="removeItem(index)">
                                    <i class="fal fa-trash-alt"></i>
                                </span>
                            </div>
                        </div>
                        <transition name="list">
                            <div :id="'collapse-'+index"  :style="`${item.open ? 'margin-top:-30px' : ''}`" v-if="item.open">
                                <div class="row py-3 align-items-center card-form">
                                    <div class="col-12 form-group">
                                        <label class="w-100 py-2 cursor-pointer" @click="collapse(index,item)">Pergunta</label>
                                        <TinyEditor
                                            :textContent="item.title"
                                            @contentText="verifyLength($event,index,'title')"
                                            customClass="mt-3"
                                            :heightEditor="70"
                                            placeholder="Digite uma pergunta..."
                                        ></TinyEditor>
                                        <span class="alert-message" v-if="errors.title">{{ errors.title }}</span>
                                    </div>
                                    <div 
                                        class="col-12 form-group" 
                                        v-if="item.type != 'option'">
                                        <label>Descrição</label>
                                        <TinyEditor
                                            :textContent="item.text"
                                            @contentText="verifyLength($event,index,'text')"
                                            :heightEditor="110"
                                            customClass="mt-3"
                                            placeholder="Adicione a descrição da resposta..."
                                        ></TinyEditor>
                                        <span class="alert-message" v-if="errors.text">{{ errors.text }}</span>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </draggable>
        <div class="row mt-4 text-right">
            <div class="col-12 text-center">
                <button class="btn px-4 btn-primario btn-small" @click="addNewInput">Nova pergunta</button>
            </div>
        </div>

        <alertScreen 
            :showAlertScreen="this.showAlert"
            :alertTitle="'Remover campo'"
            :alertText="'Deseja realmente remover este campo?'"
            @returnAlertScreen="removeInput($event)"
        />
    </div>

</template>

<script>
    import TinyEditor from "@/components/organisms/TinyEditor.vue"
    import draggable from 'vuedraggable';
    import alertScreen from '../molecules/AlertScreen'
    export default {
        name: "organismFaq",
        props: {
            formContent:{
                type: Object,
                required: false
            }
        },
        data(){
            return{
                showAlert: false,
                itemToRemove: '',
                totalForm: [],
                errors:{},
            }
        },
        filters: {
            editText(content) {
				if(content) {
					content = content.replace(/(<([^>]+)>|(\&nbsp\;))/gi,"")
					if (content.length > 80) {
						content = content.replace(
							/^([\s\S]{1,80})[\s]+?[\s\S]+/,"$1");
						content = content + "...";
					}
				}
				return content;
            }
        },
        created(){
            if(this.formContent.frameContent.content){
                this.totalForm = this.formContent.frameContent.content;
            }
            for (let i = 0; i < this.totalForm.length; i++) {
                this.$set(this.totalForm[i], 'open', false);
            }
        },
        watch:{
            totalForm: { 
                    handler: function () {
                        if(this.totalForm.length == 0){
                            this.$store.commit("BLOCK_POST", true);
                        }else{
                            for (let i = 0; i < this.totalForm.length; i++) {
                                this.totalForm[i].name = i;
                            }
                        }
                        this.$emit('updateForm', this.totalForm);
                        this.$store.commit("BLOCK_POST", false);
                    },deep: true,
            }
        },
        methods:{
            collapse(index,item){
                if(item.open == undefined){
                    this.$set(this.totalForm[index], 'open', true);
                }
                else{
                    item.open = !item.open
                }
                for (let i = 0; i < this.totalForm.length; i++) {
                    if(i !== index){
                        this.totalForm[i].open = false
                    }
                }
                return item
            },
            addInputSelect(item){
                if(!item.value){
                item.value= []
                }
                item.value.push('')
                return item
            },
            verifyLength(event,index,name){
                this.totalForm[index][name] = event
                if (this.totalForm[index][name] && this.totalForm[index][name].length > 0)
                    this.$delete(this.errors, name); 
                else 
                    this.$set(this.errors, name, 'Campo vazio');
                    
            },
            verifyTitle(title){
                if(title){
                return title
                }else{
                return "Campo vazio"
                }
            },
            addNewInput(){
                for (let i = 0; i < this.totalForm.length; i++) {
                    this.totalForm[i].open = false
                }
                this.totalForm.push({
                "type" : "text",
                "title" : "",
                "text" : "",
                "open" : true,
                })
            },
            removeItem(index){
                this.itemToRemove = index;
                this.showAlert = true
            },
            removeItemSelect(item,index){
                item.value.splice(index,1)
            },
            removeInput(event){
                if(event){
                this.totalForm.splice(this.itemToRemove, 1);
                this.itemToRemove = ''
                }else{
                this.itemToRemove = ''
                }
                this.showAlert = false
            }
        },
        components:{
            draggable,
            alertScreen,
            TinyEditor
        }
    }
</script>

<style scoped>
    .header-card i, .header-card p{
        cursor: pointer;
    }
    .list-actions {
        display: flex;
    }
    .list-actions i{
        cursor: pointer;
    }
    .card{
        min-height: 85px;
        justify-content: center;
        border-radius: 0.5rem;
    }
    .card .form-control{
        padding-left: 0;
        padding-right: 0;
    }
    .card .form-group label{
        margin-bottom: 0;
        font-size: 0.8rem;
        font-weight: 700;
        color: #777;
        opacity: 0.8;
    }
    .alert-message{
        font-size: 0.8rem;
        color: #f22;
    }
    .title-group{
        font-weight: 700;
        margin-bottom: 20px;
    }
    .border-dashed{
        border-style: dashed;
        margin-bottom: 5px;
        border-width: 1px;
        text-align: center;
    }
        .card-form{
        margin-left: 5px ;
        margin-right: 5px ;
    }
    @media (min-width: 750px) {
        .card-form{
            margin-left: 40px ;
            margin-right: 40px ;
        }
        .t-y{
            transform: translateY(5px)
        }
    }
    @media (max-width: 500px) {
        .t-y{
            display:none !important
        }
    }
    .card-title{
        font-size: 14px;
        text-transform: uppercase;
    }
    .card-text{
        font-size: 14px;
    }
    .handle{
        padding-left: 21px;
        padding-right: 19px
    }
    .handle.align-items-center{
        display:flex
    }
    .list-actions{
        z-index: 5;
    }
</style>


// WEBPACK FOOTER //
// src/components/blocks/FaqComponent.vue